import React from "react";
import { getFileUrl } from "../core/config/api.js";

const fileIdOf = (file) => (file && typeof file === "object" ? file.id : file);

const SelectableImageList = ({ files, onChange, checkedImages }) => {
  if (!files?.length) return null;

  return (
    <div className="folder-image-grid">
      {files.map((file) => {
        const fileId = fileIdOf(file);
        return (
          <div key={fileId} className="folder-image-cell">
            <div className="rug-card">
              <img className="rug-card-image" src={getFileUrl(fileId)} alt="" />
            </div>
            <label className="rug-card-checkbox">
              <input
                type="checkbox"
                onChange={(e) => onChange(e, fileId)}
                checked={checkedImages.has(fileId)}
              />
              <span className="rug-card-checkbox__tick" />
            </label>
          </div>
        );
      })}
    </div>
  );
};

export default SelectableImageList;
